import clsx from "clsx";
import { Fragment, useEffect, useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import { Transition } from "@headlessui/react";

const Navbar = () => {
    const currentLocation = useLocation().pathname;

    const token = window.localStorage.getItem("token");

    const [isOpen, setIsOpen] = useState(false);

    const navigation = [
        { id: 1, title: "Products", path: "/proxy" },
        { id: 2, title: "Pricing", path: "/pricing" },
        { id: 3, title: "Datacenters", path: "/datacenter" },
        { id: 4, title: "Affiliates", path: "/affiliates" },
        { id: 5, title: "Location", path: "#" },
        { id: 6, title: "Company", path: "#" }
    ];

    useEffect(() => {
        if (isOpen) {
            document.body.style.overflow = "hidden";
        } else {
            document.body.style.overflow = "";
        }
    }, [isOpen]);
    return (
        <Fragment>
            <nav className="w-full border-b border-neutral-30 absolute z-[9999] bg-neutral-10">
                <div className="px-6 tablet:px-8 desktop:px-20 mt-0 tablet:mt-[-5px] desktop:mt-[-4px] phone:mt-[-8px] phone:pb-4 pb-5 mx-auto w-full flex items-center justify-between">
                    <div className="w-full flex items-center justify-between">
                        <Link to="/">
                            <img className="phone:w-[130px] phone:h-[24px] tablet:w-[183px] tablet:h-[34px]" src="/images/universal/anonymousproxies.svg" width="213px" height="40px" alt="logo" />
                        </Link>
                        <div className="hidden desktop:flex items-center space-x-8">
                            {navigation.map((item) => (
                                <NavLink to={item.path} className={clsx(
                                    "text-sm leading-text text-baseus-circle-regular tracking-text",
                                    currentLocation === item.path ? "text-primary-main font-semibold" : "text-neutral-100"
                                )}>{item.title}</NavLink>
                            ))}
                            {token ? (
                                <NavLink to="/dashboard" className={clsx(
                                    "text-sm leading-text text-baseus-circle-regular tracking-text",
                                    "text-neutral-100"
                                )}>Dashboard</NavLink>
                            ) : (
                                <>
                                    <Link to="/auth/signin"><p className="text-sm text-neutral-100 leading-text text-baseus-circle-semibold font-semibold tracking-text">Sign In</p></Link>
                                    <Link to="/auth/signup"><p className="text-sm text-neutral-10 text-baseus-circle-semibold font-semibold tracking-text flex items-center justify-center h-[40px] px-[21.5px] rounded-lg bg-primary-main hover:bg-primary-hover transition-all leading-[17px]">Sign Up</p></Link>
                                </>
                            )}
                        </div>
                    </div>
                    <div className="flex tablet:w-fit md:space-x-4 justify-between">
                        <button
                            onClick={() => setIsOpen(!isOpen)}
                            type="button"
                            className="inline-flex desktop:hidden items-center justify-center rounded-md text-primary-main focus:outline-none "
                            aria-controls="mobile-menu"
                            aria-expanded="false"
                        >
                            <span className="sr-only">Open main menu</span>
                            {!isOpen
                                ? (
                                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M4 6H20M4 12H20M4 18H20" stroke="black" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                    </svg>
                                )
                                : (
                                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M19 5L5 19M5 5L19 19" stroke="black" strokeWidth="2" strokeLinecap="round" stroke-Linejoin="round" />
                                    </svg>
                                )}
                        </button>
                    </div>
                </div>

                <Transition
                    show={isOpen}
                    enter="transition ease-out duration-100 transform"
                    enterFrom="opacity-0 scale-95"
                    enterTo="opacity-100 scale-100"
                    leave="transition ease-in duration-75 transform"
                    leaveFrom="opacity-100 scale-100"
                    leaveTo="opacity-0 scale-95"
                >
                    {(ref) => (
                        <div className="desktop:hidden" id="mobile-menu">
                            <div ref={ref} className="pb-4 pt-[10px] phone:px-[10px] border-t border-neutral-30 flex flex-col mt-0 mb-0">
                                {navigation.map((item) => (
                                    <NavLink to={item.path} className={clsx(
                                        "text-sm leading-text text-baseus-circle-regular tracking-text",
                                        "px-6 tablet:px-8 desktop:px-4 hover:bg-neutral-20 py-4 font-gilroy-medium text-text-m hover:cursor-pointer",
                                        currentLocation === item.path ? "text-primary-main" : "text-neutral-100"
                                    )}>{item.title}</NavLink>
                                ))}
                                {token ? (
                                    <NavLink to="/dashboard" className={clsx(
                                        "w-full text-sm leading-text text-baseus-circle-regular tracking-text",
                                        "text-neutral-100",
                                        "phone:px-10 tablet:px-8 desktop:px-0 phone:hover:bg-neutral-20 phone:py-4"
                                    )}>Dashboard</NavLink>
                                ) : ""}
                            </div>
                            {token ? (
                                ""
                            ) : (
                                <div className="px-6 tablet:px-8 desktop:px-0 py-6 border-t border-neutral-30 flex phone:justify-between items-center gap-[25px] w-full">
                                    <Link to="/auth/signin" className="w-fit phone:w-full tablet:w-[141px] text-center text-sm text-primary-main leading-text py-[11.5px] tablet:px-[41px] rounded-lg font-semibold bg-primary-surface tracking-text"><p>Sign In</p></Link>
                                    <Link to="/auth/signup" className="w-fit phone:w-full tablet:w-[141px] text-sm text-neutral-10 font-semibold leading-text py-[11.5px] tablet:px-[41px] text-center rounded-lg bg-primary-main hover:bg-primary-hover transition-all"><p>Sign Up</p></Link>
                                </div>
                            )}
                        </div>
                    )}
                </Transition>
            </nav>
        </Fragment >
    );
};

export default Navbar;